var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-treemap m-chart-block__container--default-highlight"},[_c('Chart',{attrs:{"options":_vm.chartOptions}}),_c('p',{staticClass:"f-ui-3"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }